import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import CreatedWithUrlToast from '@/components/toasts/CreatedWithUrlToast';

const UserGroupCreatedToast = ({ code, name }) => (
  <CreatedWithUrlToast
    className="aridhia-usergroup-created-toast"
    messageId="toast.your.usergroup"
    name={name}
    url={codeUrl(urls.USER_GROUPS, code)}
  />
);

export default UserGroupCreatedToast;
